import React from "react";

import Section from "../../Section";
import SecondaryTitle from "../../Titles/SecondaryTitle";
import OurServicesData from "../../../AppData/OurServicesData";

const OurServices = () => {
  return (
    <Section className='py-20 bg-bg-cream'>
      <div className='max-w-screen-xl mx-auto px-6 lg:px-16'>
        {/* Header Section */}
        <div className='text-center mb-16'>
          <div className='inline-block mb-4'>
            <span className='text-accent-gold text-sm uppercase font-semibold tracking-widest'>Our Expertise</span>
          </div>
          <SecondaryTitle title='Premium Hair & Beauty Services' animation='fade-up' />
          <div className='luxury-divider mx-auto'></div>
          <p className='paragraph text-sm sm:text-base md:text-lg lg:text-xl max-w-2xl mx-auto mt-6'>
            Our dedicated team brings together professional expertise, cutting-edge techniques, and premium products to deliver exceptional results tailored to your unique style.
          </p>
        </div>

        {/* Services Grid */}
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'>
          {OurServicesData.map((service) => (
            <div
              key={service.id}
              className='group card-elegant border-2 border-accent-gold/20 hover:border-accent-gold/50 p-8 text-center
                transform hover:scale-105 hover:shadow-lg-gold
                transition-all duration-300 ease-out'
              data-aos='fade-up'
              data-aos-delay={service.id * 100}>

              {/* Icon Container */}
              <div className='inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-accent-gold/20 to-accent-emerald/20 rounded-lg mb-6 group-hover:from-accent-gold/30 group-hover:to-accent-emerald/30 transition-all duration-300'>
                <span className='text-4xl'>{service.icon}</span>
              </div>

              {/* Content */}
              <h3 className='font-serif text-xl font-semibold mb-3 text-text-primary'>
                {service.title}
              </h3>
              <p className='text-text-secondary leading-relaxed text-sm sm:text-base md:text-base lg:text-base'>
                {service.description}
              </p>

              {/* Hover Accent */}
              <div className='mt-6 h-1 w-12 bg-accent-gold mx-auto rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300'></div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default OurServices;
